import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { cn } from '@/lib/utils'
import type { RecentSaleEntry } from '@/types/dashboard'

export function RecentSales({
  recentSales,
  isMember = false,
  fullWidth = false,
}: {
  recentSales: RecentSaleEntry[]
  isMember?: boolean
  fullWidth?: boolean
}) {
  return (
    <Card className={cn(fullWidth && '@4xl/main:col-span-2')}>
      <CardHeader>
        <CardTitle>{isMember ? 'Suas Vendas Recentes' : 'Vendas Recentes'}</CardTitle>
        <CardDescription>
          {isMember ? 'Suas últimas 20 vendas' : 'Últimas 20 vendas registradas'}
        </CardDescription>
      </CardHeader>
      {recentSales.length === 0 ? (
        <div className="text-muted-foreground px-6 pb-6 text-sm">
          Nenhuma venda registrada.
        </div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              {!isMember && <TableHead>Vendedor</TableHead>}
              <TableHead>Comprador</TableHead>
              <TableHead className="text-right">Data/Hora</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {recentSales.map((sale) => (
              <TableRow key={sale.id}>
                {!isMember && (
                  <TableCell className="font-medium">
                    {sale.sellerName}
                  </TableCell>
                )}
                <TableCell>{sale.buyerName}</TableCell>
                <TableCell className="text-muted-foreground text-right">
                  {new Date(sale.createdAt).toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Card>
  )
}
